import $api from '../../utils/api.js'


const state = () => ({
    themes: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    themes_type:[
        {label:"Wedding",value:"Wedding"},
        {label:"Wedding & Mapandes",value:"Wedding & Mapandes"},
        {label:"Mapandes",value:"Mapandes"},
        {label:"Birth Day",value:"Birth Day"},
    ],
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Theme'
    },
    formdata:{
        id:'',
        name:'',
        is_show:'true',
        photo:'',
        code:'',
        type:'',
        main_bg:'',
        second_bg:'',
        third_bg:'',
        main_tx:'',
        second_tx:'',
        third_tx:''
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.themes = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            name:payload.name,
            is_show:payload.is_show,
            photo:payload.photo,
            code:payload.code,
            type:payload.type,
            main_bg:payload.main_bg,
            second_bg:payload.second_bg,
            third_bg:payload.third_bg,
            main_tx:payload.main_tx,
            second_tx:payload.second_tx,
            third_tx:payload.third_tx
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            name:'',
            is_show:'true',
            photo:'',
            code:'',
            type:'',
            main_bg:'',
            second_bg:'',
            third_bg:'',
            main_tx:'',
            second_tx:'',
            third_tx:''
        },
        state.errors = []
    },
    CLEAR_THEMES(state){
        state.themes = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getThemes({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`themes?page=${state.themes.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createThemes({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`themes`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    updateThemes({ state,commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`themes/${state.formdata.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    deleteThemes({ dispatch }, payload) {
        return new Promise((resolve,reject) => {
            $api.delete(`themes/${payload}`)
            .then(() => {
                dispatch('getThemes').then(() => resolve())
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}